var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "el-form",
              {
                staticStyle: { "margin-bottom": "5px" },
                attrs: { inline: true, "label-position": "left" },
                nativeOn: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "90px",
                      label: _vm.$t("baseInfo.operation.lobType")
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("common.tips.pleaseChoose"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.searchConditions.lob,
                          callback: function($$v) {
                            _vm.$set(_vm.searchConditions, "lob", $$v)
                          },
                          expression: "searchConditions.lob"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("common.tips.pleaseChoose"),
                            value: ""
                          }
                        }),
                        _vm._l(_vm.lobArray, function(item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.name, value: item.code }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "90px",
                      label: _vm.$t("baseInfo.operation.operationType")
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("common.tips.pleaseChoose"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.searchConditions.operationRequirementType,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.searchConditions,
                              "operationRequirementType",
                              $$v
                            )
                          },
                          expression:
                            "searchConditions.operationRequirementType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("common.tips.pleaseChoose"),
                            value: ""
                          }
                        }),
                        _vm._l(_vm.operationRequirementTypeArray, function(
                          item
                        ) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.name, value: item.code }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": _vm.$selectByLang(
                        "90px",
                        "90px",
                        "90px",
                        "180px",
                        "180px",
                        "180px"
                      ),
                      label: _vm.$t("baseInfo.operation.contentDescription")
                    }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "260px" },
                      attrs: {
                        size: "mini",
                        placeholder: _vm.$t(
                          "baseInfo.operation.enterContentDescription"
                        )
                      },
                      on: {
                        change: function($event) {
                          _vm.searchConditions.pageNum = 1
                        }
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.fetchSysOperationRequirementDescriptionList(
                            $event
                          )
                        }
                      },
                      model: {
                        value: _vm.searchConditions.contentDescription,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.searchConditions,
                            "contentDescription",
                            $$v
                          )
                        },
                        expression: "searchConditions.contentDescription"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: _vm.fetchSysOperationRequirementDescriptionList
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.query")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.popOperationPortAddFormDialog }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.new")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.popOperationPortEditFormDialog }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.edit")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "danger" },
                        on: { click: _vm.toBatchDel }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "100301",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "show-side-bar": false
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.searchConditions.total > 0,
                      expression: "searchConditions.total>0"
                    }
                  ],
                  attrs: {
                    "config-module": "100301",
                    total: _vm.searchConditions.total,
                    page: _vm.searchConditions.pageNum,
                    limit: _vm.searchConditions.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.searchConditions, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.searchConditions, "pageSize", $event)
                    },
                    pagination: _vm.fetchSysOperationRequirementDescriptionList
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.isShowOperationMaintain
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog",
              attrs: {
                slot: "reference",
                "close-on-click-modal": false,
                visible: _vm.isShowOperationMaintain,
                title: _vm.$t("baseInfo.operation.operationMaintain"),
                "inline-message": "",
                width: "500px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isShowOperationMaintain = $event
                }
              },
              slot: "reference"
            },
            [
              _c(
                "el-form",
                {
                  ref: "operationForm",
                  attrs: {
                    model: _vm.operationForm,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.operation.code"),
                        prop: "code"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.operationForm.code,
                          callback: function($$v) {
                            _vm.$set(_vm.operationForm, "code", $$v)
                          },
                          expression: "operationForm.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.operation.lob"),
                        prop: "lob"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          filterable: "",
                          headers: ["name"],
                          fields: ["name"],
                          "callback-params": { key: "lob" },
                          "callback-method-type": "code",
                          "default-value": _vm.operationForm.lob,
                          "tag-value": "code",
                          "tag-name": "name",
                          "static-options": _vm.lobArray,
                          "filter-tag-names": ["name"]
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "baseInfo.operation.operationRequirementType"
                        ),
                        prop: "operationRequirementType"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          filterable: "",
                          headers: ["name"],
                          fields: ["name"],
                          "callback-params": {
                            key: "operationRequirementType"
                          },
                          "callback-method-type": "code",
                          "default-value":
                            _vm.operationForm.operationRequirementType,
                          "tag-value": "code",
                          "tag-name": "name",
                          "static-options": _vm.operationRequirementTypes,
                          "filter-tag-names": ["name"]
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _vm.isAirExportHandlingInfo
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Tool.b2bWebsite") } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.operationForm.isB2bPageVisible,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.operationForm,
                                    "isB2bPageVisible",
                                    $$v
                                  )
                                },
                                expression: "operationForm.isB2bPageVisible"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Tool.pageDisplay")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.operationForm.isB2bFieldRequired,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.operationForm,
                                    "isB2bFieldRequired",
                                    $$v
                                  )
                                },
                                expression: "operationForm.isB2bFieldRequired"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Tool.required")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isAirExportHandlingInfo
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Tool.b2bWebsiteDisplay") } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.b2bOrderContentLanguage,
                                callback: function($$v) {
                                  _vm.b2bOrderContentLanguage = $$v
                                },
                                expression: "b2bOrderContentLanguage"
                              }
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: "b2bContentZh" } },
                                [_vm._v(_vm._s(_vm.$t("Tool.Chinese")))]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "b2bContentEn" } },
                                [_vm._v(_vm._s(_vm.$t("Tool.English")))]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "b2bContentJp" } },
                                [_vm._v(_vm._s(_vm.$t("Tool.Japanese")))]
                              )
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              disabled: !_vm.operationForm.isB2bPageVisible
                            },
                            model: {
                              value:
                                _vm.operationForm[_vm.b2bOrderContentLanguage],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.operationForm,
                                  _vm.b2bOrderContentLanguage,
                                  $$v
                                )
                              },
                              expression:
                                "operationForm[b2bOrderContentLanguage]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.operation.contentDescription"),
                        prop: "contentDescription"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: 512,
                          rows: 6,
                          size: "mini"
                        },
                        model: {
                          value: _vm.operationForm.contentDescription,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.operationForm,
                              "contentDescription",
                              $$v
                            )
                          },
                          expression: "operationForm.contentDescription"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.operation.remark"),
                        prop: "remark"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: 255,
                          rows: 6,
                          size: "mini"
                        },
                        model: {
                          value: _vm.operationForm.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.operationForm, "remarks", $$v)
                          },
                          expression: "operationForm.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini ", type: "primary" },
                      on: { click: _vm.submitOperationRequirementDescription }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini " },
                      on: { click: _vm.cancelSaveOrEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }